import { NavLink } from 'react-router-dom';
import AdminLayout from '../../layout/AdminLayout';
import { useModal } from '../../hooks/modalContext';

import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

export default function EmployRegister(){
  const { openModal } = useModal();

  const [salesList, setSalesList] = useState([]);
  const [totalList, setTotalList] = useState([]);

  const [param, setParam] = useState({
    salesPersonName: '',
  });

  const handleAdd = () => {
    openModal({
      modalName: 'TobAccountModal',
      modalData: {
        isRegi: true,
        data: {
          item: {},
          callback: getSalesPersonList,
        },
      }
    });
  };

  // 🟢 행 클릭 시 해당 item을 팝업으로 넘기는 핸들러
  const handleRowClick = (item) => {
    openModal({
      modalName: 'TobAccountModal',
      modalData: {
        isRegi: false,
        data: {
          item: item,
          callback: getSalesPersonList,
        },
      }
    });
  };

  const getSalesPersonList = () => {
    Server.sendGet('shopify/sales/list', param, getSalesPersonListCallback).then();
  }

  const getSalesPersonListCallback = res => {
    const result = res?.['resultObject'];
    setSalesList(result['personList']);
    setTotalList(result['totalList']);
  }

  const openOrgWindow = (e, salesPersonId) => {
    e.stopPropagation(); // 🟢 행 클릭 이벤트 버블링 방지
    window.open(`/admin/organization?salesPersonId=${salesPersonId}`, 'popupWindow', 'width=1573, height=900');
  }

  useEffect(() => {
    getSalesPersonList();
  }, [param.salesPersonName]);

  return (
    <AdminLayout>
      <div className='title'>
        <div className='tit-head'>
          <i />
          <h4>Member Status</h4>
        </div>
      </div>
      <div className="util-menu">
        <div className="menu-in">
          <div className="item-in">
            <label htmlFor="search">Search</label>
            <input
              type="text"
              name="search"
              id="search"
              placeholder="REF ID / Name"
              onChange={e => setParam(() => {
                return {
                  ...param,
                  salesPersonName: e.target.value
                }
              })}
            />
          </div>
          <button>Search</button>
          <button
            onClick={handleAdd}
          >Add Sales Person</button>
        </div>
      </div>

      <SummaryContent>
        <table className="summary-table">
          <tbody>
          <tr>
            <th>Type (Lv)</th>
            {totalList?.map((item, idx) => (
              <td key={`lv-${idx}`}>{item.lv}</td>
            ))}
            <th className="total-label">합계</th>
          </tr>
          <tr>
            <th>Count</th>
            {totalList?.map((item, idx) => (
              <td key={`count-${idx}`}>{item.gcount}</td>
            ))}
            <td className="total-value">
              <strong>
                {totalList?.reduce((acc, cur) => acc + Number(cur.gcount || 0), 0)} 명
              </strong>
            </td>
          </tr>
          </tbody>
        </table>
      </SummaryContent>

      <div className="content">
        <table className="admin-table">
          <thead>
          <tr>
            <th>Member Name</th>
            <th>Region</th>
            <th>City</th>
            <th>Total Sales</th>
            <th>Last order date</th>
            <th>DOJ</th>
            <th>Referral ID (Self)</th>
            <th>Referral ID (Upline)</th>
            <th>View Downline Structure</th>
          </tr>
          </thead>
          <tbody>
          {salesList?.map((item, idx) => (
            <tr
              key={idx}
              onClick={() => handleRowClick(item)} // 🟢 행 클릭 이벤트
              style={{ cursor: 'pointer' }}
            >
              <td>{item.salesPersonName}</td>
              <td>{item.regionCode}</td>
              <td>{item.city}</td>
              <td>{item.totalSales}</td>
              <td>{item.lastSalesDate}</td>
              <td>{item.regDate}</td>
              <td>{item.referralId}</td>
              <td>{item.upReferralId}</td>
              <td>
                <Btn
                  onClick={(e) => openOrgWindow(e, item.salesPersonId)} // 🟢 버블링 방지 처리
                >View</Btn>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  )
}

const SummaryContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 25px;

  .summary-table {
    border-collapse: collapse;
    background: #fff;
    border: 1px solid #e2e8f0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    overflow: hidden;

    th, td {
      padding: 10px 15px;
      border: 1px solid #e2e8f0;
      text-align: center;
      font-size: 13px;
      white-space: nowrap;
    }

    th {
      background: #f8fafc;
      color: #64748b;
      font-weight: 600;
      min-width: 80px;
    }

    td {
      color: #1a1f36;
      font-weight: 500;
      min-width: 60px;
    }

    .total-label {
      background: #eff6ff;
      color: #2F80ED;
      border-left: 2px solid #2F80ED;
    }

    .total-value {
      background: #fdfdfd;
      border-left: 2px solid #2F80ED;
      strong {
        color: #2F80ED;
        font-size: 15px;
      }
    }
  }
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : (props.$Delete ? '#FF4848' : '#a4a4a4'))};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : (props.$Delete ? '#FF2424' : '#7e7e7e'))};
  }
`;
